import dynamicModuleRegistry from 'dynamic-module-registry';
import React from 'react';
import { hydrate } from 'react-dom';
import { ClientApp as Main } from 'pf-onboarding-v2-ui';
import 'base-layout';
var props = dynamicModuleRegistry.get('props') || {};
if (props.useAlternateFlow) {
  hydrate( /*#__PURE__*/React.createElement(Main, props), document.getElementById('landing-container'));
} else {
  require('get-info-enroll');
}
require('/var/lib/jenkins/workspace/pf-onboarding-ui_Release_0/src/pages/enroll/enroll.scss');